import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import jspdf from 'jspdf';

export interface compra {
  cursoTitulo: string;
  cursoPrecioOriginal: number;
  cursoPorcentajeDescuento: number;
  cursoPrecioFinal: number;
  transaccionMoneda: string;
  transaccionTax: number;
  transaccionFecha: any;
  transaccionEstatusCobro: string;
  transaccionViaCobro: string;
  transaccionId: string;
  transaccionComentario: string;
  instructorNombre: string;
}

export interface datosFact {
  razonSocial: string;
  nif: string;
  direccion: string;
  cp: string;
  pais: string;
  email: string;
  tlf: string;
}

@Component({
  selector: 'historial-compras-estudiante',
  templateUrl: './historial-compras-estudiante.component.html',
  styleUrls: ['./historial-compras-estudiante.component.css']
})
export class HistorialComprasEstudianteComponent implements OnInit {

  usuario: any;
  compras: compra[] = [];
  datosFact: datosFact;
  logo: string = "assets/images/logos/logo.svg"
  logoPNG: string = "assets/images/logos/logo.png"
  loaded: number = 1;

  constructor(
    private afs: AngularFirestore,
  ) { }

  ngOnInit(): void {
    this.usuario = JSON.parse(localStorage.getItem('user'));
    this.cargarCompras()
  }

  cargarCompras() {
    this.afs.collection('usuariosCompras').ref.where('usuarioId', "==", this.usuario.uid).get().then(response => {
      response.docs.forEach(doc => {
        const data = doc.data();
        const compra: compra = {
          cursoTitulo: data["cursoTitulo"],
          cursoPrecioOriginal: data["cursoPrecioFinal"],
          cursoPorcentajeDescuento: data["cursoPorcentajeDescuento"],
          cursoPrecioFinal: data["cursoPrecioFinal"],
          transaccionMoneda: data["transaccionMoneda"],
          transaccionTax: data["transaccionTax"],
          transaccionFecha: data["transaccionFecha"],
          transaccionEstatusCobro: data["transaccionEstatusCobro"],
          transaccionViaCobro: data["transaccionViaCobro"],
          transaccionId: data["transaccionId"],
          transaccionComentario: data["transaccionComentario"],
          instructorNombre: data["instructorNombre"],
        }
        this.compras = this.compras.concat(compra);
        this.cargarDatosFact();
      })
    }).catch(error => {
    });
  }

  cargarDatosFact() {
    this.afs.collection('usuariosDatosFacturacion').doc(this.usuario.uid).ref.get().then(doc => {
      const datos = doc.data();
      this.datosFact = {
        razonSocial: datos['razonSocial'], //
        nif: datos['nif'],
        direccion: datos['direccion'],
        cp: datos['cp'],
        pais: datos['pais'],
        email: datos['email'], 
        tlf: datos['tlf'],
      }
      this.loaded = 1;
    }).catch(error => {
      console.log(error)
      alert('No se ha cargar los datos de facturacion')
    });
  }

  
  downloadPDF(i) {
    var doc = new jspdf('p', 'mm', [297, 210]);

    doc.setFont('helvetica')
    doc.setFontSize(9)
    doc.setTextColor(21, 27, 38)
    doc.text(this.compras[i].transaccionFecha.toDate('short').toString(),19,13)
    doc.setFontSize(13)
    doc.setFont('helvetica', 'bold')
    doc.text('Invoice', 19, 23) // titulo Invoice
    doc.line(19, 28, 180, 28)
    doc.addImage(this.logoPNG, 'PNG', 167, 7, 10, 10)
    doc.text('Predyc', 164, 23) // titulo Invoice

    // Datos de Predyc 
    doc.setFont('Predyc', 'normal')
    doc.setFontSize(10)
    doc.setTextColor(21, 27, 38)
    doc.text('Predictiva21 LLC', 19, 40) // titulo Invoice
    doc.text('EIN: 352712281', 19, 45) // titulo Invoice
    doc.text('1908 Sawdust Rd., The woodlands. ', 19, 50) // titulo Invoice
    doc.text('Texas 77380', 19, 55) // titulo Invoice

    // Datos de cliente 
    doc.setFont('Predyc', 'normal')
    doc.setFontSize(10)
    doc.setTextColor(21, 27, 38)
    doc.text('Razón social: ' + this.datosFact.razonSocial, 90, 40) // titulo Invoice
    doc.text('Núm. de Identificación fiscal: ' + this.datosFact.nif, 90, 45) // titulo Invoice
    doc.text('Dirección: ' + this.datosFact.direccion, 90, 50) // titulo Invoice
    doc.text('Código postal: ' + this.datosFact.cp, 90, 55) // titulo Invoice
    doc.text('País: ' + this.datosFact.pais, 90, 60) // titulo Invoice
    doc.text('Email: ' + this.datosFact.email, 90, 65) // titulo Invoice

    // Datos de compra (Header)
    doc.setFont('Predyc', 'normal')
    doc.setFontSize(10)
    doc.setTextColor(21, 27, 38)
    doc.setFont('Predyc', 'bold')
    doc.text('Descripción', 19, 112)
    doc.text('Precio', 170, 112)

    doc.setFont('Predyc', 'normal')
    var tituloCurso = doc.splitTextToSize(this.compras[i].cursoTitulo, 170)
    doc.text('1            Curso: ' + tituloCurso, 19, 120)
    doc.text('$ ' + this.compras[i].cursoPrecioOriginal, 170, 120)
    doc.line(19, 128, 180, 128)
    doc.text('Descuento:'.toString(), 130, 135)
    doc.text(this.compras[i].cursoPorcentajeDescuento.toString() + '%', 170, 135)
    doc.text('Sub total (USD):'.toString(), 130, 140)
    doc.text('$ ' + this.compras[i].cursoPrecioFinal.toString(), 170, 140)
    doc.text('TAX (USD):', 130, 145)
    doc.text('$ ' + this.compras[i].transaccionTax.toString(), 170, 145)
    doc.line(130, 148, 180, 148)
    doc.setFont('Predyc', 'bold')
    doc.text(('Total (USD):').toString(), 130, 153)
    doc.text('$ ' + (this.compras[i].transaccionTax + this.compras[i].cursoPrecioFinal).toString(), 170, 153)

    doc.save('certificado.pdf')
  }


}
